
const AssignSvg = ({className}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.37744 5.58008L8.99994 9.41258L15.5774 5.60258"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.2073V9.40479"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44748 1.85997L3.44248 4.07997C2.53498 4.58247 1.79248 5.84247 1.79248 6.87747V11.115C1.79248 12.15 2.53498 13.41 3.44248 13.9125L7.44748 16.14C8.30248 16.6125 9.70498 16.6125 10.56 16.14L14.565 13.9125C15.4725 13.41 16.215 12.15 16.215 11.115V6.87747C16.215 5.84247 15.4725 4.58247 14.565 4.07997L10.56 1.85247C9.69748 1.37997 8.30248 1.37997 7.44748 1.85997Z"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AssignSvg;
